import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const CompanyName = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('organizationName', {
          required: t('mainReporting:form.mandatory'),
        })}
        label={t('mainReporting:form.companyName.label')}
        placeholder={t('mainReporting:form.companyName.placeholder')}
      />
      <InputError error={error} />
    </>
  )
}

export default CompanyName
